import { config, debug, george, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { NavigationBar } from "components/common/NavigationBar";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { TPPDetails } from "./TPPDetails";
import { TPPList } from "./TPPList";
import { TPPRoutes } from "./TPPRoutes";
import { TPPSigning } from "./TPPSigning";
import { TPPStore } from "./TPPStore";
import { TPPSuccess } from "./TPPSuccess";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class TPPContainer extends React.Component<IProps, {}> {
    tppStore: TPPStore;

    constructor(props: any) {
        super(props);
        this.tppStore = new TPPStore();
    }

    async componentDidMount() {
        pushRoute(TPPRoutes.ROOT);
        try {
            if (auth.authorized) {
                await this.tppStore.load();
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.tppStore} />;
    }

    render() {
        document.title = ui.__("tpp.document.title");

        const details = [
            {
                path: "details",
                title: ui.__("tpp.navbar.details")
            },
        ];

        return (
            <george.Background>

                {/* Navbar for list details */}
                <NavigationBar
                    basePath="/tpp"
                    pages={details}
                    path={this.props.location.pathname}
                    backToBase
                    hideProgress
                />

                <Route exact path={TPPRoutes.ROOT} component={this.withStore(TPPList)} />
                <Route path={TPPRoutes.DETAILS} component={this.withStore(TPPDetails)} />
                <Route path={TPPRoutes.SIGNING} component={this.withStore(TPPSigning)} />
                <Route path={TPPRoutes.SUCCESS} component={this.withStore(TPPSuccess)} />
            </george.Background>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tpp/TPPContainer.tsx